import clsx from 'clsx';

interface StatusBadgeProps {
  status: string;
  statusText: string;
}

function StatusBadge({ status, statusText }: StatusBadgeProps) {
  const Elem = 'div';
  return (
    <Elem
      className={clsx([
        'flex h-lg shrink-0 items-center rounded-sm px-sm text-tag-sm',
        status === 'draft' && 'border border-solid border-border bg-white text-main',
        status === 'pending_archived' &&
          'border border-solid border-danger bg-danger text-white no-underline',
        status === 'archived' &&
          'border border-solid border-danger bg-danger text-white no-underline',
        status === 'new' && 'bg-tag-green text-tag-green',
      ])}
    >
      <div className="flex">{statusText}</div>
    </Elem>
  );
}

interface JobPostStatusProps {
  id: number;
  status: string;
  created_at?: string;
}

export default function JobPostStatusBadge({ status, created_at }: JobPostStatusProps) {
  // ステータス表示の判定
  const getDisplayStatus = () => {
    // 下書き
    if (status === 'draft') {
      return { show: true, status: 'draft', text: '下書き' };
    }

    // 連携求人削除
    if (status === 'pending_archived') {
      return { show: true, status: 'pending_archived', text: '連携先クローズ' };
    }

    if (status === 'archived') {
      return { show: true, status: 'archived', text: 'クローズ' };
    }

    // 新規（作成から1日以内）
    if (created_at) {
      const createdDate = new Date(created_at);
      const oneDaysAgo = new Date();
      oneDaysAgo.setDate(oneDaysAgo.getDate() - 1);
      if (createdDate > oneDaysAgo) {
        return { show: true, status: 'new', text: '新規' };
      }
    }

    // それ以外は表示しない
    return { show: false, status: '', text: '' };
  };

  const displayStatus = getDisplayStatus();

  if (!displayStatus.show) {
    return null;
  }

  return <StatusBadge status={displayStatus.status} statusText={displayStatus.text} />;
}
